import { gql, useMutation } from '@apollo/client'

const mutation = gql`
   mutation removeNote($id: ID!) {
      removeNote(id: $id) {
         id
      }
   }
`

const useRemoveNote = (mutationHookOptions = {}) => {
   const [removeNote, { called, client, data, error, loading }] =
      useMutation(mutation, mutationHookOptions)

   const wrappedMutationFn = (variables, mutationFnOptions) => removeNote({
      variables,
      ...mutationFnOptions
   })

   return {
      removeNote: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useRemoveNote
